import { stringify } from 'qs'
import assert from './assert'

const gatewayApiUrl = '/gateway-api'

export const graphqlUrl = (): string => `${gatewayApiUrl}/graphql`
export const restUrl = (): string => `${gatewayApiUrl}/rest`
export const loginApi = (): string => `${gatewayApiUrl}/rest/login`
export const mfaLoginApi = (): string => `${gatewayApiUrl}/rest/login-mfa`
export const resendVerificationApi = (): string => `${gatewayApiUrl}/rest/resend-verification`
export const sendRecoveryCodeApi = (): string => `${gatewayApiUrl}/rest/send-mfa-recovery`
export const sendSmsApi = (): string => `${gatewayApiUrl}/rest/send-sms`
export const logoutApi = (): string => `${gatewayApiUrl}/rest/logout`

export const privacyCatalogCSVDownload = (args: { workspaceId: string }): string => {
  return `${gatewayApiUrl}/rest/privacy/workspace/${args.workspaceId}/catalog.csv`
}

export const privacySourceVolumeCSVDownload = (args: {
  workspaceId: string
  propertyName: string
  startTime: string
}): string => {
  const prop = encodeURIComponent(args.propertyName)
  return `${gatewayApiUrl}/rest/privacy/workspace/${args.workspaceId}/source-volume/${prop}/report.csv?startTime=${
    args.startTime
  }`
}

export const privacyPreClassificationsCSVDownload = (args: { workspaceId: string }): string => {
  return `${gatewayApiUrl}/rest/privacy/workspace/${args.workspaceId}/pre-classification-report.csv`
}

export const privacySourceVisibility = (args: {
  fieldName: string
  workspaceId: string
  resolution?: string
  endTime: string
  startTime: string
}): string => {
  const { workspaceId, resolution = 'day', startTime, endTime, fieldName } = args

  return `${gatewayApiUrl}/rest/privacy/workspace/${workspaceId}/source-volume/${fieldName}?startTime=${startTime}&endTime=${endTime}&resolution=${resolution}`
}

export const privacySourceVisibilityCSV = (args: {
  fieldName: string
  workspaceId: string
  startTime: string
}): string => {
  const { workspaceId, startTime, fieldName } = args
  return `${gatewayApiUrl}/rest/privacy/workspace/${workspaceId}/source-volume/${fieldName}/report.csv?startTime=${startTime}`
}

export const auditDownloadEvents = (args: { workspaceId: string }): string => {
  return `${gatewayApiUrl}/rest/audit/${args.workspaceId}/events.csv`
}

export function ssoLoginApi(args: {
  email: string
  connectionId?: string
  loginChallenge?: string
  segmentUniversityPath?: string
}): string {
  assert(args, 'email')

  const query = stringify({
    email: args.email,
    connectionId: args.connectionId,
    loginChallenge: args.loginChallenge,
    segmentUniversityPath: args.segmentUniversityPath
  })

  return `${gatewayApiUrl}/rest/sso/login?${query}`
}

export function ssoSkilljarLoginAPI(args: { userId: string; segmentUniversityPath: string }): string {
  assert(args, 'userId')
  assert(args, 'segmentUniversityPath')
  const query = stringify({
    userId: args.userId,
    segmentUniversityPath: args.segmentUniversityPath
  })
  return `${gatewayApiUrl}/rest/sso/skilljar-login?${query}`
}
